"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLoop = void 0;
const validateLoop = (loop) => {
    if (typeof loop === 'undefined') {
        return;
    }
    if (typeof loop !== 'boolean') {
        throw new TypeError(`The "loop" prop must be a boolean or undefined, but is "${JSON.stringify(loop)}"`);
    }
};
exports.validateLoop = validateLoop;
